<mat-dialog-content [formGroup]="providerForm">
    <div class="flex flex-col">
        <h1 for="type" class="text-gray-700">Tipo</h1>
        <select id="type" (change)="assingType($event)" formControlName="type" matNativeControl
            class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <option value="">Seleccione un tipo</option>
            <option value="monetic">Monético</option>
            <option value="non_monetic">No monético</option>
        </select>
    </div>
    <div class="flex flex-col">
        <h1 for="status" class="text-gray-700">Estado</h1>
        <select id="status" (change)="assingState($event)" formControlName="status" matNativeControl
            class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <option value="">Seleccione un estado</option>
            <option value="active">Activo</option>
            <option value="inactive">No activo</option>
        </select>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-between">
    <button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded" mat-button
        type="submit" (click)="updateProvider()">Guardar</button>
    <button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded" mat-button
        (click)="closeModal()">Cancelar</button>
</mat-dialog-actions>